export const de = {
  hero: {
    badge: '7 Tage kostenlos testen',
    title: 'Die Handwerkersoftware',
    titleHighlight: 'aus der Cloud',
    subtitle: 'Aufträge, Angebote, Rechnungen, Zeiterfassung und mehr - alles in einer Lösung. Jetzt kostenlos starten.',
    features: [
      'Auftragsverwaltung & Projektplanung',
      'Angebote & Rechnungen in Sekunden',
      'Zeiterfassung & Mitarbeiterverwaltung',
      'Mobil auf allen Geräten verfügbar',
    ],
  },
  form: {
    title: 'Jetzt kostenlos registrieren',
    subtitle: 'KOSTENLOS REGISTRIEREN & TESTEN',
    salutation: 'Anrede',
    herr: 'Herr',
    frau: 'Frau',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    website: 'Webseite',
    company: 'Firma',
    newsletter: 'Ich möchte den Newsletter erhalten',
    agb: 'Ich akzeptiere die AGB und Datenschutzbestimmungen',
    submit: 'Kostenlos registrieren',
    submitting: 'Wird registriert...',
    errors: {
      firstname: 'Vorname ist erforderlich',
      lastname: 'Nachname ist erforderlich',
      email: 'Gültige E-Mail-Adresse erforderlich',
      company: 'Firmenname ist erforderlich',
      phone: 'Gültige Telefonnummer ist erforderlich',
      website: 'Bitte geben Sie eine vollständige Webadresse ein (z. B. https://firma.de)',
      agb: 'Bitte akzeptieren Sie die AGB',
      general: 'Bitte überprüfen Sie die markierten Felder.',
      failed: 'Die Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    },
  },
  poll: {
    title: 'Helfen Sie uns, Sie besser kennenzulernen',
    step: 'Schritt',
    of: 'von',
    skip: 'Überspringen',
    next: 'Weiter',
    finish: 'Abschließen',
    saving: 'Antwort wird gespeichert…',
    completing: 'Umfrage wird abgeschlossen…',
    saveError: 'Ihre Antwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    completeError: 'Die Umfrage konnte nicht abgeschlossen werden. Ihre Registrierung war dennoch erfolgreich.',
    retry: 'Erneut versuchen',
    continue: 'Ohne Umfrage fortfahren',
    questions: {
      position: 'Was ist Ihre Position?',
      employees: 'Wie viele Mitarbeiter hat Ihr Unternehmen?',
      software: 'Welche Software nutzen Sie aktuell?',
      improvements: 'Welche Bereiche möchten Sie verbessern?',
      trade: 'In welchem Gewerk sind Sie tätig?',
    },
  },
  success: {
    title: 'Willkommen bei openHandwerk!',
    message: 'Ihre Registrierung war erfolgreich. Sie erhalten in Kürze eine E-Mail mit Ihren Zugangsdaten.',
    cta: 'Zur Anmeldung',
  },
  footer: {
    copyright: 'openHandwerk GmbH',
    privacy: 'Datenschutz',
    imprint: 'Impressum',
  },
};
